import type { Prototype } from "../prototype-types";

export const haoyangDingPrototypes: Prototype[] = [
  {
    id: "hyd-signup-store-info-options",
    name: "Signup Store Info Options",
    path: "/hyd/signup-store-info-options",
    description: "Three alternative designs for the retailer signup store-info screen for retailers whose store isn&#39;t on Google Maps yet",
    owner: "Haoyang Ding",
    createdAt: "2026-07-14",
    lastUpdated: "2026-07-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/2eced6eb54e6fc4019d96402bb25e5cecdd35e1f22f768e33c1f5ed9abfce5f0.png",
    creationTool: "claude-code",
  },
  {
    id: "hyd-identifying-opening-soon-retailers-on-brand-portal",
    name: "Identifying opening soon retailers on brand portal",
    path: "/hyd/identifying-opening-soon-retailers-on-brand-portal",
    description: "Identifying opening soon retailers on brand portal",
    owner: "Haoyang Ding",
    createdAt: "2026-07-16",
    lastUpdated: "2026-07-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/47d3aa6664e79b346607b1ee9be3cdc3eb67ff35cf6ecbec414c6c3f642a4b7d.png",
    creationTool: "claude-code",
  }
];
